import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import SettingsDropdown from 'common/SettingsDropdown';
import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { useStackedScrollingModalities } from './ViewerSettingsTab';
import { MODALITIES } from 'config/constants';
import { SettingsMenuItem } from 'common/SettingsDropdown/SettingsDropdown';
import { Checkbox } from '@material-ui/core';
import { Colors } from 'styles';

export const StackedScrollingSettings = ({
  setError,
}: {
  setError: Dispatch<SetStateAction<string | null>>;
}): React.ReactElement => {
  const [userStackedModalities, handleUserStackedModalitiesChange] =
    useStackedScrollingModalities(setError);

  // Using local state to keep track of selected items for the server request upon close
  const [stackedModalities, setStackedModalities] =
    useState<ReadonlyArray<string>>(userStackedModalities);

  useEffect(() => {
    setStackedModalities(userStackedModalities);
  }, [userStackedModalities]);
  return (
    <Stack alignY="center" vertical={true} alignX="start" css={{ paddingLeft: '16px' }}>
      <Text variant="body2">Modalities</Text>
      <SettingsDropdown
        multiple={true}
        value={stackedModalities}
        onSelectedChange={(value) => {
          // We should not ever not have an array with multiple true.
          // Since the value is a union there is a type warning that it might not be what we expect
          if (Array.isArray(value)) {
            setStackedModalities(value);
          }
        }}
        onClose={() => {
          handleUserStackedModalitiesChange(undefined, stackedModalities);
        }}
        data-testid="stacked-scrolling-modalities"
      >
        {MODALITIES.map((option) => (
          <SettingsMenuItem
            id={`select-menuitem-${option.value}`}
            value={option.value}
            key={option.value}
            data-testid={`${option.value}-menu-item`}
          >
            <Checkbox
              color="primary"
              css={`
                color: ${Colors.blue4};
              `}
              checked={stackedModalities.includes(option.value)}
            />
            {option.name}
          </SettingsMenuItem>
        ))}
      </SettingsDropdown>
    </Stack>
  );
};
